import template	from "./dialog-config.html";
import css		from "./dialog-config.css";

import Dialog	from "dialog";


class ConfigRGBSensorDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-rgbsensor", ConfigRGBSensorDialog);
  }
  connectedCallback() {
    super.connectedCallback();

    this.onupdatedevices_handler_f = this.onupdatedevices_handler.bind(this);
    document.addEventListener("onupdatedevices", this.onupdatedevices_handler_f);

    this.onupdatedevices_handler({detail: application.devices});    
  }
  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener("onupdatedevices", this.onupdatedevices_handler_f);
  }  
  constructor(...args) {
    super(...args);

    this.show(...args);
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.rgbSensor.id;    
    this.textboxDeviceStatus.value = devices.rgbSensor.status;
    this.spinnerRed.value = devices.rgbSensor.red;
    this.spinnerGreen.value = devices.rgbSensor.green;
    this.spinnerBlue.value = devices.rgbSensor.blue;
    this.spinnerLux.value = devices.rgbSensor.lux;
    this.rangeTargetLEDBrightness.value = devices.rgbSensor.targetLEDBrightness;
    this.checkboxPowerSaving.checked = devices.rgbSensor.powerSaving;
  }  
  async checkboxPowerSaving_change() {
    server.rcall("RM_RGBSensor_setTargetLEDBrightness", this.rangeTargetLEDBrightness.value, this.checkboxPowerSaving.checked);
  }
  async rangeTargetLEDBrightness_change() {
    server.rcall("RM_RGBSensor_setTargetLEDBrightness", this.rangeTargetLEDBrightness.value, this.checkboxPowerSaving.checked);
  }
  buttonClose_click() {
    this.close();
  }
}

ConfigRGBSensorDialog.constructor();

export default ConfigRGBSensorDialog;